export const PERCENT_TO_SHOW_UPSELL_WIDGET = 22;